import { render } from "./AssetFormView.vue?vue&type=template&id=56e3b9fd&scoped=true"
import script from "./AssetFormView.vue?vue&type=script&lang=js"
export * from "./AssetFormView.vue?vue&type=script&lang=js"

import "./AssetFormView.vue?vue&type=style&index=0&id=56e3b9fd&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-56e3b9fd"]])

export default __exports__